import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export function CampaignAnalyticsPlaceholder({
  campaignId,
  campaignName,
}: Readonly<{
  campaignId: string
  campaignName: string
}>) {
  return (
    <Box
      data-testid="campaign-analytics-placeholder"
      sx={{
        bgcolor: '#F9FAFB',
        width: '100%',
        maxWidth: { xs: '100%', md: 960 },
        mx: 'auto',
        py: 6,
        px: 3,
        textAlign: 'center',
      }}
    >
      <Typography
        component="h1"
        sx={{
          fontWeight: 700,
          fontSize: '24px',
          lineHeight: '32px',
          color: '#0F1729',
          mb: 1,
        }}
      >
        Analytical Dashboard
      </Typography>
      <Typography sx={{ fontSize: '14px', color: '#4A5565', mb: 3 }}>
        Response analytics for {campaignName} are coming soon.
      </Typography>
      <Button
        component={RouterLink}
        to={`/campaigns/${campaignId}`}
        variant="outlined"
        data-testid="campaign-analytics-back-to-launch"
        sx={{ textTransform: 'none', borderRadius: '8px' }}
      >
        Back to Launching Screen
      </Button>
    </Box>
  )
}
